const INIT_STATE = {
  submittingDemo: false,
  userMessage: ""
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "SUBMITTING_TRIAL_REQUEST": {
      return {
        ...state,
        submittingTrial: true
      };
    }
    case "TRIAL_REQUEST_DONE": {
      console.log(action.payload);
      return {
        ...state,
        ...action.payload,
        submittingTrial: false
      };
    }
    default: {
      return state;
    }
  }
};
